/**
* DevExpress Dashboard (federated-query-configure-page.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { FederationDataSourceWizardPageId, _registerFederatedQueryConfigurePage as _registerAnalyticFederatedQueryConfigurePage } from '@devexpress/analytics-core/analytics-wizard';
export function _registerFederatedQueryConfigurePage(factory, wizardOptions) {
    let analyticsMeta = factory.getMetadata(FederationDataSourceWizardPageId.FederatedQueryConfigurePage);
    if (!analyticsMeta) {
        _registerAnalyticFederatedQueryConfigurePage(factory, wizardOptions);
        analyticsMeta = factory.getMetadata(FederationDataSourceWizardPageId.FederatedQueryConfigurePage);
    }
    let dashboardMeta = { ...analyticsMeta };
    let analyticsMetaCreate = analyticsMeta.create;
    dashboardMeta.create = () => {
        let page = analyticsMetaCreate();
        page.canNext = () => false;
        return page;
    };
    factory.unregisterMetadata(FederationDataSourceWizardPageId.FederatedQueryConfigurePage);
    factory.registerMetadata(FederationDataSourceWizardPageId.FederatedQueryConfigurePage, dashboardMeta);
}
